module.exports = __webpack_public_path__ + "static/media/hideCollapse.3e483555.svg";